import {
    SET_STATES,
    SET_SELECTED_STATE,
    SET_SUPPLIERS,
    // SET_RATE_CLASSES,
    // SET_SELECTED_RATE_CLASSES,
    FETCH_ERROR,
    SET_CHARTSDATA,
    SET_TERMS,
    SET_SELECTED_TERM,
    SET_FROM_DATE,
    SET_TO_DATE,
    SET_EFFECTIVE_FROM_DATE,
    SET_EFFECTIVE_TO_DATE,
    SET_START_FROM_DATE,
    SET_START_TO_DATE,
    SET_COMMODITY,
    SET_CHARTSDATA_LOADER,
    SET_SELECTED_UTILITY,
    SET_SELECTED_RATE_CLASS,
    SET_SELECTED_LOAD_PROFILE,
    SET_SELECTED_LOAD_ZONE,
    SET_SELECTED_BILLING_METHOD,
    SET_USAGE,
    SET_DEMAND,
    SET_LOAD_FACTOR,
    SET_MARKETS,
    SET_SELECTED_MARKET,
    SET_PRODUCT_TYPES,
    SET_SELECTED_ProductType,
    SET_COST_COMPONENTS,
    SET_SELECTED_COST_COMPONENT,
    SET_CUSTOMER_CLASS,
    SET_TAX_INCLUDED,
    SET_POR
  } from '../types/index';
  import { PricingState, HyperThemeDropDown } from '../state/index';
  import {convertDeltaBestToChartData, convertToApexChartsMinMaxPlots, convertToApexChartsPlots} from './utils';

  const initialState: PricingState = {
    commodity: null,
    states: [],
    markets: [],
    terms: [],
    // utilities: [],
    // loadZones: [],
    // suppliers: [],
    // rateClasses: [],
    chartsData: null,
    fromDate: null,
    toDate: null,
    effectiveFromDate: null,
    effectiveToDate: null,
    startFromDate: null,
    startToDate: null,
    error: null,
    selectedState: null,
    selectedMarket: null,
    selectedUtility: null,
    selectedRateClass: null,
    selectedLoadProfile: null,
    selectedBillingMethod: null,
    selectedLoadZone: null,
    rateClasses: [],
    loadZones: [],
    billingMethods: [],
    productTypes: [],
    costComponents: [],
    customerClass: "COMM",
    taxIncluded: null,
    por: null,
    usage: null,
    demand: null,
    loadFactor: null
  };
  
  const pricingReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case SET_STATES:
        return { ...state, states: action.payload };
      case SET_SELECTED_STATE:
        return { ...state, selectedState: action.payload };
      case SET_MARKETS:
        return { ...state, markets: action.payload };
      case SET_SELECTED_MARKET:
        // debugger;
        return { ...state, selectedMarket: action.payload };
        // const updatedStatesList = state.states.map((state: HyperThemeDropDown) =>
        //     state.value === action.payload
        //       ? { ...state, isSelected: true }
        //       : { ...state, isSelected: false }
        //   );
        // return { ...state, states: updatedStatesList };
      // TODO: make setting and selecting generic for all dropdowns
      case SET_TERMS:
        return { ...state, terms: action.payload };
      case SET_SELECTED_TERM:
        const updatedTermsList = state.terms.map((term: HyperThemeDropDown) =>
            term.value === action.payload
              ? { ...term, isSelected: true }
              : { ...term, isSelected: false }
          );
        return { ...state, terms: updatedTermsList };
      case SET_FROM_DATE:
        return { ...state, fromDate: action.payload };
      case SET_TO_DATE:
        return { ...state, toDate: action.payload };
      case SET_EFFECTIVE_FROM_DATE:
        return { ...state, effectiveFromDate: action.payload };
      case SET_EFFECTIVE_TO_DATE:
        return { ...state, effectiveToDate: action.payload };
      case SET_START_FROM_DATE:
        return { ...state, startFromDate: action.payload };
      case SET_START_TO_DATE:
        return { ...state, startToDate: action.payload };
      case SET_COMMODITY:
        return { ...state, commodity: action.payload };
      // case SET_UTILITIES:
      //   return { ...state, utilities: action.payload };
      case SET_SELECTED_UTILITY:
        return { ...state, selectedUtility: action.payload };
      case SET_SELECTED_LOAD_ZONE:
        return { ...state, selectedLoadZone: action.payload };
      case SET_SELECTED_BILLING_METHOD:
        return { ...state, selectedBillingMethod: action.payload };
      // case SET_LOAD_ZONES:
      //   return { ...state, loadZones: action.payload };
      // case SET_SUPPLIERS:
      //   return { ...state, suppliers: action.payload };
      // case SET_RATE_CLASSES:
      //   return { ...state, rateClasses: action.payload };
      case SET_SELECTED_RATE_CLASS:
        return { ...state, selectedRateClass: action.payload };
      case SET_SELECTED_LOAD_PROFILE:
        return { ...state, selectedLoadProfile: action.payload };
      case SET_USAGE:
        return { ...state, usage: action.payload };
        case SET_PRODUCT_TYPES:
                return { ...state, productTypes: action.payload };
                // case SET_SELECTED_ProductType:
                // const updatedProductList = state.productTypes.map((productType: HyperThemeDropDown) =>
                //     productType.value === action.payload
                //       ? { ...productType, isSelected: true }
                //       : { ...productType, isSelected: false }
                //   );
                // return { ...state, productTypes: updatedProductList };
                case SET_SELECTED_ProductType:

  const updatedProductList = state.productTypes.map((productType: any) => ({
    ...productType,
    isSelected: action.payload.includes(productType.value),
  }));
  return { ...state, productTypes: updatedProductList };

  case SET_COST_COMPONENTS:
            return { ...state, costComponents: action.payload };
            
          case SET_SELECTED_COST_COMPONENT:
            const updatedCostComponentList = state.costComponents.map((costComponent: any) => ({
              ...costComponent,
              isSelected: action.payload.includes(costComponent.value),
            }));
            return { ...state, costComponents: updatedCostComponentList };
      case SET_CUSTOMER_CLASS:
        return { ...state, customerClass: action.payload };
      case SET_TAX_INCLUDED:
        return { ...state, taxIncluded: action.payload };
      case SET_POR:
        return { ...state, por: action.payload };
      case SET_DEMAND:
        return { ...state, demand: action.payload };
      case SET_LOAD_FACTOR:
        return { ...state, loadFactor: action.payload };
      case SET_CHARTSDATA:
        const key = action.payload?.key;
        const chartsData = convertDeltaBestToChartData(action.payload?.chartsData);
        
        // key.includes('MinMax') ? convertToApexChartsMinMaxPlots(action.payload?.chartsData, key): convertDeltaBestToChartData(action.payload?.chartsData, key);
        if(chartsData)
          chartsData.isLoading = action.payload?.isLoading || false;
        return {
          ...state,
          chartsData: {
            ...state.chartsData, // copy previous chartsData
            [key]: chartsData    // overwrite or add the new one
          }
        };
      case SET_CHARTSDATA_LOADER: {
        const { key, isLoading } = action.payload;
        const existingData = state.chartsData[key] || {};
        return {
          ...state,
          chartsData: {
            ...state.chartsData,
            [key]: {
              ...existingData,
              isLoading
            }
          }
        };
      }
      case FETCH_ERROR:
        return { ...state, error: action.payload };
      default:
        return state;
    }
  };
  
  export default pricingReducer;
  
